<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1251_1071)">
      <path
        d="M25.3334 8.54667L23.4534 6.66667L16 14.12L8.54669 6.66667L6.66669 8.54667L14.12 16L6.66669 23.4533L8.54669 25.3333L16 17.88L23.4534 25.3333L25.3334 23.4533L17.88 16L25.3334 8.54667Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
